import { functions } from '../utils/firebase';

export const getWidgetHistory = params => {
  return functions.httpsCallable('Reports-widgetOnCall')(params);
};
